export default "__VITE_ASSET__DoOe_xal__"